import type { RouteRecordRaw } from "vue-router";
import { RouteName } from "@/App/router/routeName";
import { RoutePath } from "@/App/router/routePath";

export const routes: RouteRecordRaw[] = [
  { path: "/", redirect: RoutePath.cases },
  {
    path: RoutePath.cases,
    component: () => import("@/Pages/Cases/CasesPage.vue"),
    meta: { bigBoardAllowed: true },
    children: [
      {
        path: RoutePath.cases,
        name: RouteName.cases,
        component: () => import("@/Pages/Cases/pages/CasesIndex.vue"),
      },
      {
        path: ":id",
        name: RouteName.edCaseDetails,
        component: () => import("@/Pages/Cases/pages/CasesIndex.vue"),
      },
    ],
  },
  {
    path: RoutePath.ift,
    component: () => import("@/Pages/Cases/CasesPage.vue"),
    children: [
      {
        path: RoutePath.ift,
        name: RouteName.ift,
        component: () => import("@/Pages/Cases/pages/CasesIndex.vue"),
      },
      {
        path: ":id",
        name: RouteName.iftCaseDetails,
        component: () => import("@/Pages/Cases/pages/CasesIndex.vue"),
      },
    ],
  },
  {
    path: RoutePath.iftReports,
    name: RouteName.iftReports,
    component: () => import("@/Pages/IftReports/IftReportsPage.vue"),
  },
  {
    path: RoutePath.mih,
    component: () => import("@/Pages/Cases/CasesPage.vue"),
    children: [
      {
        path: RoutePath.mih,
        name: RouteName.mih,
        component: () => import("@/Pages/Cases/pages/CasesIndex.vue"),
      },
      {
        path: ":id",
        name: RouteName.mihCaseDetails,
        component: () => import("@/Pages/Cases/pages/CasesIndex.vue"),
      },
    ],
  },
  {
    path: RoutePath.mihReports,
    name: RouteName.mihReports,
    component: () => import("@/Pages/MihReports/MihReportsPage.vue"),
  },
  {
    path: RoutePath.messaging,
    name: RouteName.messaging,
    component: () => import("@/Pages/BroadcastMessage/BroadcastMessagePage.vue"),
  },
  {
    path: RoutePath.statuses,
    name: RouteName.statuses,
    component: () => import("@/Pages/Statuses/StatusesPage.vue"),
  },
  {
    path: RoutePath.logout,
    name: RouteName.logout,
    component: () => import("@/Pages/Logout/LogoutPage.vue"),
  },
  {
    path: RoutePath.login,
    name: RouteName.login,
    meta: { requiresAuthorization: false, redirectToCasesIfAuthorized: true },
    component: () => import("@/Pages/Login/Login.vue"),
  },
  {
    path: RoutePath.authHandleToken,
    name: RouteName.handleSsoToken,
    meta: { requiresAuthorization: false, redirectToCasesIfAuthorized: true },
    component: () => import("@/Pages/Login/Sso/AuthHandleToken.vue"),
  },
  {
    path: RoutePath.reset,
    name: RouteName.passwordReset,
    meta: { requiresAuthorization: false },
    component: () => import("@/Pages/Reset/ResetPage.vue"),
  },
  {
    path: RoutePath.forgot,
    name: RouteName.passwordForgot,
    meta: { requiresAuthorization: false },
    component: () => import("@/Pages/Forgot/ForgotPage.vue"),
  },
  {
    component: () => import("@/Pages/SetNewPassword/SetNewPassword.vue"),
    meta: { requiresAuthorization: false },
    path: RoutePath.setNewPassword,
  },
  {
    path: "/404",
    component: () => import("@/Pages/404/NotFound.vue"),
    meta: { requiresAuthorization: false },
  },
  { path: "/:pathMatch(.*)*", redirect: "/404" },
];
